import { mergeOptions } from '../../utils/style';
import { BaseEdge } from './base-edge';
/**
 * <zh/> 直线
 *
 * <en/> Line
 * @remarks
 * <img width="300" src="https://mdn.alipayobjects.com/huamei_qa8qxu/afts/img/A*YbpvTa4liAEAAAAAAAAAAAAADmJ7AQ/original" />
 */
export class Line extends BaseEdge {
    static defaultStyleProps = {};
    constructor(options) {
        super(mergeOptions({ style: Line.defaultStyleProps }, options));
    }
    getKeyPath(attributes) {
        const [sourcePoint, targetPoint] = this.getEndpoints(attributes);
        return [
            ['M', sourcePoint[0], sourcePoint[1]],
            ['L', targetPoint[0], targetPoint[1]],
        ];
    }
}
//# sourceMappingURL=line.js.map